import PropTypes from 'prop-types';
import React from 'react';
import { css } from '@emotion/core';
import RoundelAttributeIcon from './RoundelAttributeIcon';
import styleVars from '../design-system/scss-vars';
import { mediaBreakpointUpMD, mediaBreakpointUpLG, mediaBreakpointUpXL } from '../constants/style-constants';
import Paragraph from '../design-system/Paragraph';
import { HeadingSub } from '../design-system/Headings';

const QualityCard = ({ id, name, description }) => (
  <div
    key={id}
    className="col-10 col-md-6 col-lg-4 mx-auto"
    css={css`
      padding-left: ${styleVars.ssSpaceLg};
      padding-right: ${styleVars.ssSpaceLg};
      margin: ${styleVars.ssSpaceLg} 0 ${styleVars.ssSpaceXl};

      ${mediaBreakpointUpMD} {
        margin: ${styleVars.ssSpaceLg} 0;
        box-shadow:
          inset 1px 0 0 ${styleVars.ssPrimaryDark},
          inset -1px 0 0 ${styleVars.ssPrimaryDark};

        &:first-of-type {
          box-shadow: inset 1px 0 0 ${styleVars.ssPrimaryDark};
        }

        &:last-of-type {
          margin: ${styleVars.ssSpaceSm} 0 ${styleVars.ssSpaceXl};
        }
      }

      ${mediaBreakpointUpLG} {
        padding-left: ${styleVars.ssSpaceXl};
        padding-right: ${styleVars.ssSpaceXl};
        box-shadow: inset 1px 0 0 ${styleVars.ssPrimaryDark};

        &:last-of-type {
          margin: ${styleVars.ssSpaceLg} 0;
          box-shadow:
            inset 1px 0 0 ${styleVars.ssPrimaryDark},
            inset -1px 0 0 ${styleVars.ssPrimaryDark};
        }
      }

      ${mediaBreakpointUpXL} {
        padding-left: ${styleVars.ssSpaceXl};
        padding-right: ${styleVars.ssSpaceXl};
      }`
    }
  >
    <RoundelAttributeIcon id={id} />
    <HeadingSub>{name}</HeadingSub>
    <Paragraph secondary>{description}</Paragraph>
  </div>
);

QualityCard.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default QualityCard;
